import React, { useEffect, useState } from 'react';

import { getResourcePlacesSearch } from '../../api/resourcePlaces';
import AutocompleteFetchInput from '../../presentation/components/inputs/autocomplete-fetch-input';

const CustomerFilter = ({ clearFilter, onChange, accountId }) => {
  const [selectedCustomerOptions, setSelectedCustomerOptions] = useState([]);

  const handleCustomerChange = (data) => {
    setSelectedCustomerOptions(data);
    onChange(data.map((customer) => customer.value));
  };

  useEffect(() => {
    if (clearFilter) {
      setSelectedCustomerOptions([]);
    }
  }, [clearFilter]);

  const fetchCustomers = async (q) => {
    try {
      const params = { viewMode: ['Customer'], accountId, q: q };
      const result = await getResourcePlacesSearch(params);

      const options = result.results
        .map((item) => ({ label: item.name, value: item.id }))
        .sort((a, b) => a.label.localeCompare(b.label));

      return options;
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AutocompleteFetchInput
      label="Clientes"
      value={selectedCustomerOptions}
      setValue={handleCustomerChange}
      fetchOptions={fetchCustomers}
    />
  );
};

export default CustomerFilter;
